module.exports = __webpack_public_path__ + "img/onitsukatiger-close2.cca9d4d0.svg";